import type { MigrationStrategies } from "./_types/migration-strategies";

// v0 → v1: switch from random uuid `id` to deterministic `${userId}|${key}` so
// emit() is an atomic upsert. v0 rows used random uuid; drop them so the
// producer adapter can re-emit with the canonical id on next reactive tick
// (notifications are local-only and re-derived from producer state — ADR-004 §4).
// v1 → v2: `id` maxLength widened from 300 to 320 to fit max-length composite
// keys (userId 100 + "|" + key 200 = 301). Identity transform — existing rows
// pass the new constraint.
export const NOTIFICATION_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: () => null,
  2: (oldDoc) => oldDoc,
};
